/**
 * @author        patrick@zumper.com (Patrick Giddings)
 * @copyright     Copyright (c) 2021, Zumper
 * @description   criticalAssetsContext.ts
 */

import { createContext } from 'react'

import { CriticalAssetsContext } from './types'

export const defaultCriticalAssetsContext = {
  registerCriticalAsset: /* istanbul ignore next */ () => {},
} as const

export const criticalAssetsContext = createContext<
  CriticalAssetsContext | undefined
>(defaultCriticalAssetsContext)
